import React, { Fragment, useState, useContext, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom'; // Corrected import for useParams
import { updateData, postData, fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CopyrightIcon from '@mui/icons-material/Copyright';

const BankCreate = () => {
    const { id: recordId } = useParams(); // Use useParams to get the record ID from the URL
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    //Balance Sheet
    const [balancesheetOptions, setBalanceSheetOptions] = useState([]);
    const [selectedBalanceSheetType, setSelectedBalanceSheetType] = useState("");

    const fetchBalanceSheet = async () => {
        try {
            const response = await fetchData('BalanceSheetApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(balance => ({
                    value: balance.id,
                    label: balance.name
                }));
                setBalanceSheetOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleBalanceSheetChange = (selectedOption) => {
        setSelectedBalanceSheetType(selectedOption);
    };

    useEffect(() => {
        fetchBalanceSheet();
    }, []);

    const [formData, setFormData] = useState({
        Name: '',
        IFSCCode: '',
        AccountNumber: '',
        Branch: '',
        BalanceSheetHeadId: selectedBalanceSheetType.value,
        IsPayableOrReceivable: true,
        OpeningBalance: 0,
        ContactNumber: '',
        AddressLine1: '',
        AddressLine2: '',
        CompanyId: companyId,
        IsPrimary: false,
        PaymentQRcodeUPIID: '',
        UPIName: '',
    });

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : type === 'radio' ? value === 'true' : value,
        }));
    };

    const submitData = (event) => {
        event.preventDefault();
        setIsLoading(true);

        const CreateData = {
            ...formData,
            UpdatedBy: userId,
            CompanyId: companyId,
            BalanceSheetHeadId: selectedBalanceSheetType.value,
        };

        if (!formData.Name) { // Check if the category is selected
            setErrorMessage("Name is required!");
            setIsLoading(false);
            return;
        }

        if (!formData.AccountNumber) { // Check if the category is selected
            setErrorMessage("Account Number is required!");
            setIsLoading(false);
            return;
        }

        if (!formData.IFSCCode) { // Check if the category is selected
            setErrorMessage("IFSC Code is required!");
            setIsLoading(false);
            return;
        }

        postData('BankApi', CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/BankIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    const phoneNumberPattern = /^\d{10}$/;
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;

    return (
        <Fragment>
            <div className="w-full max-w-full md:max-w-sm container mt-6 mx-auto px-4">

                {/* <form onSubmit={submitData}> */}
                <div className='w-full mb-2 flex'>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Bank Create</h6>
                    <div className="flex items-center gap-4 mt-2 md:mt-0">
                        {/* Save Button */}
                        <Button
                            variant="contained"
                            onClick={submitData}
                            disabled={isLoading}
                            style={{
                                height: "25px",
                                minWidth: "80px",
                                borderRadius: "6px",
                                backgroundColor: "#1E3A8A", // deep ERP-blue
                                color: "#FFFFFF",
                                fontWeight: 600,
                                fontSize: "13px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                textTransform: "none",
                                transition: "background-color 0.2s, box-shadow 0.2s",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#1E3A8A")}
                        >
                            {isLoading ? <CircularProgress size={20} color="inherit" /> : "Save"}
                        </Button>

                        {/* Back to List Button */}
                        <Button
                            variant="contained"
                            component={Link}
                            to="/BankIndex"
                            className="linkcolor"
                            onClick={() => localStorage.setItem("shouldReload", "true")}
                            style={{
                                height: "25px",
                                minWidth: "90px",
                                borderRadius: "6px",
                                backgroundColor: "#F3F4F6", // light gray ERP style
                                color: "#1E3A8A",
                                fontWeight: 600,
                                fontSize: "13px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                textTransform: "none",
                                transition: "background-color 0.2s, box-shadow 0.2s",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#E5E7EB")}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#F3F4F6")}
                        >
                            Back
                        </Button>
                    </div>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}

                <div className="w-full mb-4 flex flex-col md:flex-row">

                    <div className="w-full md:w-1/3 mb-2 md:mb-0 md:mr-2">

                        <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="balancesheet">
                            Balance Sheet  <span className="text-red-500">*</span>
                        </label>
                        <Select
                            value={selectedBalanceSheetType}
                            onChange={handleBalanceSheetChange}
                            options={balancesheetOptions}
                            placeholder="Balance sheet"
                            isSearchable
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderRadius: '10px',
                                    borderColor: state.isFocused ? '#667eea' : '#e5e7eb',
                                    boxShadow: state.isFocused ? '0 0 0 2px rgba(102, 126, 234, 0.1)' : 'none',
                                    '&:hover': { borderColor: '#667eea' },
                                    minHeight: '32px',
                                    height: '32px',
                                    fontSize: '13px',
                                }),
                                menu: (base) => ({
                                    ...base,
                                    fontSize: '13px',
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    fontSize: '13px',
                                    padding: '6px 10px',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    fontSize: '13px',
                                }),
                            }}
                        />
                    </div>

                    <div className="w-full md:w-full mb-2 md:mb-0 md:mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs mb-2">
                            Name
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name="Name"
                            value={formData.Name}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter name"
                            required
                            maxLength={50}
                            style={{ fontSize: '13px' }}
                        />
                    </div>

                </div>
                <div className="w-full mb-2 flex flex-col md:flex-row">

                    <div className="w-full md:w-1/5 mb-2 md:mb-0 md:mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs mb-2">
                            Contact Number
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name="ContactNumber"
                            value={formData.ContactNumber}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Contact Number"
                            required
                            maxLength={30}
                            style={{ fontSize: '13px' }}
                        />
                    </div>

                    <div className="w-full md:w-1/2 mb-2 md:mb-0 md:mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs mb-2">
                            Address Line 1
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='AddressLine1'
                            value={formData.AddressLine1}
                            onChange={handleChange} type="text"
                            placeholder="Enter Address Line 1"
                            style={{ fontSize: '13px' }}
                        />

                    </div>

                    <div className="w-full md:w-1/2 mb-2 md:mb-0 md:mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs mb-2">
                            Address Line 2
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='AddressLine2'
                            value={formData.AddressLine2}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Address Line 2"
                            style={{ fontSize: '13px' }}
                        />

                    </div>

                </div>
                <div className="w-full mb-4 flex flex-col md:flex-row">
                    <div className="w-full md:w-1/3 mb-2 md:mb-0 md:mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs mb-2">
                            Account Number
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name="AccountNumber"
                            value={formData.AccountNumber}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Account Number"
                            maxLength={40}
                            style={{ fontSize: '13px' }}
                        />
                    </div>
                    <div className="w-full md:w-1/5 mb-2 md:mb-0 md:mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs mb-2">
                            IFSC Code
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name="IFSCCode"
                            value={formData.IFSCCode}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter IFSC Code"
                            required
                            maxLength={30}
                            style={{ fontSize: '13px' }}
                        />
                    </div>

                    <div className="w-full md:w-1/5 mb-2 md:mb-0 md:mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs mb-2">
                            Opening Balance
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name="OpeningBalance"
                            value={formData.OpeningBalance}
                            onChange={handleChange}
                            type="number"
                            placeholder="Enter Opening Balance"
                            style={{ fontSize: '13px', textAlign: 'right', fontWeight: 'bold', color: 'blue' }}
                        />
                    </div>

                    <div className="w-full md:w-1/3 mb-2 md:mb-0 md:mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs mb-2">
                            UPI Name
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='UPIName'
                            value={formData.UPIName}
                            onChange={handleChange} type="text"
                            placeholder="Enter UPI Name"
                            style={{ fontSize: '13px' }}
                        />
                    </div>

                    <div className="w-full md:w-1/3 mb-2 md:mb-0 md:mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs mb-2">
                            Payment QR code UPI ID
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='PaymentQRcodeUPIID'
                            value={formData.PaymentQRcodeUPIID}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Payment QR code UPI ID"
                            style={{ fontSize: '13px' }}
                        />
                    </div>

                </div>
                <div className="w-full mb-2 flex flex-col md:flex-row">
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '16px',
                        background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                        borderRadius: '12px',
                        height: '29px'
                    }}>
                        <input
                            type="checkbox"
                            name="IsPayableOrReceivable"
                            checked={formData.IsPayableOrReceivable || false}
                            onChange={(e) =>
                                handleChange({
                                    target: {
                                        name: "IsPayableOrReceivable",
                                        value: e.target.checked,
                                    },
                                })
                            }
                            id="isPayableOrReceivableEdit"
                            style={{
                                width: '20px',
                                height: '20px',
                                cursor: 'pointer',
                                accentColor: '#f59e0b'
                            }}
                        />
                        <label
                            htmlFor="isPayableOrReceivableEdit"
                            style={{
                                color: '#78350f',
                                fontSize: '14px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                userSelect: 'none'
                            }}
                        >
                            Is Payable / Receivable
                        </label>
                    </div>

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '16px',
                        background: 'linear-gradient(135deg, #cdf5acff 0%, #befd8aff 100%)',
                        borderRadius: '12px',
                        //marginTop: '24px',
                        height: '29px',
                        marginLeft: '10px'
                    }}>
                        <input
                            type="checkbox"
                            name="IsPrimary"
                            checked={formData.IsPrimary}
                            onChange={handleChange}
                            id="IsPrimary"
                            style={{
                                width: '20px',
                                height: '20px',
                                cursor: 'pointer',
                                accentColor: '#64f013ff'
                            }}
                        />
                        <label
                            htmlFor="IsPrimary"
                            style={{
                                color: '#100e81ff',
                                fontSize: '14px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                userSelect: 'none'
                            }}
                        >
                            Is Primary ?
                        </label>
                    </div>
                </div>
                {/* </form> */}
            </div>

            <div style={{
                position: 'fixed',
                bottom: '12px',
                right: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem',
                padding: '0.3rem 0.65rem',
                background: 'rgba(255, 255, 255, 0.9)',
                borderRadius: '14px',
                boxShadow: '0 1px 6px rgba(0, 0, 0, 0.06)',
                fontFamily: 'serif',
                fontWeight: 'bold',
                color: '#2c3e50',
                fontSize: '0.7rem',
                backdropFilter: 'blur(10px)'
            }}>
                <CopyrightIcon />
                <b>EFFTABS SOLUTIONS LLP</b>
            </div>
        </Fragment>
    );
};

export default BankCreate;
